import { fromJS } from 'immutable';
import { createStructuredSelector, createSelector } from 'reselect';

import { IDENTITY_FORM_STATUS } from 'enum/profile';
import makeAction from 'utils/makeAction';


const initialState = fromJS({
  createdIdentity: null,
  currentIdentity: IDENTITY_FORM_STATUS.NO_STATUS,
  frontIdStatus: IDENTITY_FORM_STATUS.NO_STATUS,
  backIdStatus: IDENTITY_FORM_STATUS.NO_STATUS,
  captureIdStatus: IDENTITY_FORM_STATUS.NO_STATUS,
  captureNoFaceDetected: IDENTITY_FORM_STATUS.NO_STATUS,
  identityFormMode: IDENTITY_FORM_STATUS.NO_STATUS,
  identityFormStep: IDENTITY_FORM_STATUS.NO_STATUS,
});

export const NAME = 'identityOnboarding';

const RESET_STATE = 'cam4/identityOnboarding/RESET_STATE';
const CREATED_IDENTITY = 'cam4/identityOnboarding/CREATED_IDENTITY';
const IDENTITY_STATUS = 'cam4/identityOnboarding/IDENTITY_STATUS';
const FRONT_ID_STATUS = 'cam4/identityOnboarding/FRONT_ID_STATUS';
const BACK_ID_STATUS = 'cam4/identityOnboarding/BACK_ID_STATUS';
const CAPTURE_ID_STATUS = 'cam4/identityOnboarding/CAPTURE_ID_STATUS';
const CAPTURE_NO_FACE_DETECTED = 'cam4/identityOnboarding/CAPTURE_NO_FACE_DETECTED';
const FORM_STEP = 'cam4/identityOnboarding/FORM_STEP';
const FORM_MODE = 'cam4/identityOnboarding/FORM_MODE';

const resetStateToInitial = makeAction(RESET_STATE);
const updateCreatedIdentity = makeAction(CREATED_IDENTITY, 'createdIdentity');
const updateIdentityStatus = makeAction(IDENTITY_STATUS, 'identityStatus');
const updateFrontIdStatus = makeAction(FRONT_ID_STATUS, 'frontIdStatus');
const updateBackIdStatus = makeAction(BACK_ID_STATUS, 'backIdStatus');
const updateCaptureIdStatus = makeAction(CAPTURE_ID_STATUS, 'captureIdStatus');
const updateCaptureNoFaceDetected = makeAction(CAPTURE_NO_FACE_DETECTED, 'captureNoFaceDetected');
const updateFormStep = makeAction(FORM_STEP, 'identityFormStep');
const updateFormMode = makeAction(FORM_MODE, 'identityFormMode');

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case RESET_STATE:
      return initialState;

    case CREATED_IDENTITY:
      return state.set('createdIdentity', fromJS(action.createdIdentity));

    case IDENTITY_STATUS:
      return state.set('identityStatus', fromJS(action.identityStatus));

    case FRONT_ID_STATUS:
      return state.set('frontIdStatus', fromJS(action.frontIdStatus));

    case BACK_ID_STATUS:
      return state.set('backIdStatus', fromJS(action.backIdStatus));

    case CAPTURE_ID_STATUS:
      return state.set('captureIdStatus', fromJS(action.captureIdStatus));

    case CAPTURE_NO_FACE_DETECTED:
      return state.set('captureNoFaceDetected', fromJS(action.captureNoFaceDetected));

    case FORM_STEP:
      return state.set('identityFormStep', fromJS(action.identityFormStep));

    case FORM_MODE:
      return state.set('identityFormMode', fromJS(action.identityFormMode));

    default:
      return state;
  }
}

function setResetState() {
  return (dispatch) => dispatch(resetStateToInitial());
}

function setCreatedIdentity(payload) {
  return (dispatch) => dispatch(updateCreatedIdentity(payload));
}

function setIdentityStatus(payload) {
  return (dispatch) => dispatch(updateIdentityStatus(payload));
}

function setFrontIdStatus(payload) {
  return (dispatch) => dispatch(updateFrontIdStatus(payload));
}

function setBackIdStatus(payload) {
  return (dispatch) => dispatch(updateBackIdStatus(payload));
}

function setCaptureIdStatus(payload) {
  return (dispatch) => dispatch(updateCaptureIdStatus(payload));
}

function setCaptureNoFaceDetected(payload) {
  return (dispatch) => dispatch(updateCaptureNoFaceDetected(payload));
}

function setFormStep(payload) {
  return (dispatch) => dispatch(updateFormStep(payload));
}

function setFormMode(payload) {
  return (dispatch) => dispatch(updateFormMode(payload));
}

const createdIdentity = (state) => state[NAME].get('createdIdentity');
const identityStatus = (state) => state[NAME].get('identityStatus');
const frontIdStatus = (state) => state[NAME].get('frontIdStatus');
const backIdStatus = (state) => state[NAME].get('backIdStatus');
const captureIdStatus = (state) => state[NAME].get('captureIdStatus');
const captureNoFaceDetected = (state) => state[NAME].get('captureNoFaceDetected');
const identityFormStep = (state) => state[NAME].get('identityFormStep');
const identityFormMode = (state) => state[NAME].get('identityFormMode');

export const selector = createStructuredSelector({
  createdIdentity,
  identityStatus,
  frontIdStatus,
  backIdStatus,
  captureIdStatus,
  captureNoFaceDetected,
  identityFormStep,
  identityFormMode,
});

export const identityFormStatus = createSelector(identityFormMode, (identityFormStatus) => {
  return { identityFormStatus };
});

export const actionCreators = {
  setCreatedIdentity,
  setIdentityStatus,
  setFrontIdStatus,
  setBackIdStatus,
  setCaptureIdStatus,
  setCaptureNoFaceDetected,
  setFormStep,
  setFormMode,
  setResetState,
};
